import goodCompanyPNG from '~/assets/images/communication/good-company.png'
import goodCompanyWEBP from '~/assets/images/communication/good-company.webp'

export const GOOD_COMPANY_QUESTION = `You're in great company`

export { goodCompanyPNG, goodCompanyWEBP }
